// Module
var code = `<template class="voucher-graph">
  <require from="./voucher-graph.scss"></require>
  <require from="./connector-line/connector-line"></require>

  <template if.bind="loading">Loading...</template>
  <template else>
    <div class="mdc-theme--primary voucher-graph__voucher-title">Voucher details
      <mdc-segmented-button single>
        <button mdc-segmented-button-segment checked.to-view="groupMode === GroupMode. ByPrimaryTransaction" click.delegate="groupMode = GroupMode.ByPrimaryTransaction">Group by primary transaction</button>
        <button mdc-segmented-button-segment checked.to-view="groupMode === GroupMode.ByAction" click.delegate="groupMode = GroupMode.ByAction">Group by action</button>
          <button mdc-segmented-button-segment checked.to-view="groupMode === GroupMode.None" click.delegate="groupMode = GroupMode.None">Show all</button>
      </mdc-segmented-button>
    </div>
    <div>
    </div>
    <br>
    <div class="voucher-graph__voucher-details">

      <div class="voucher-graph__document" style="grid-row: 1/\${groupsCount + 1};" ref="documentDiv" mdc-ripple>
        <global-progress if.bind="!document" size="40" stroke-width="3"></global-progress>
        <span>Document</span><span></span>
        <span>Id</span> <span><a href="#" click.delegate="downloadDocument()">\${transaction.documentId}</a></span>
        <span>Received</span> <span>\${document.createdAt | dateConverter}</span>
        <span>Type</span> <span>\${document.fileType | fileTypes }</span>
      </div>
      <connector-line left.bind="documentDiv" right.bind="voucherDiv"></connector-line>

      <div class="voucher-graph__voucher" style="grid-row: 1/\${groupsCount + 1};" ref="voucherDiv" mdc-ripple>
        <span>Voucher</span><span></span>
        <span>Nr</span> <span><a href="#" click.delegate="downloadVoucher()" if.bind="transaction.externalRowId">\${transaction.voucherNr}</a><span else>
            \${transaction.voucherNr}</span></span>
      </div>

      <template if.bind="groupMode !== GroupMode.ByPrimaryTransaction">
        <template repeat.for="g of groupedByTransaction">
          <connector-line left.bind="voucherDiv" right.bind="transactionDiv"></connector-line>
          <div class="voucher-graph__transaction" mdc-ripple ref="transactionDiv" mdc-size.bind="size">
            <template if.bind="g.transaction.id">
              <span>Transaction</span><span></span>
              <span>Id</span> <span>\${g.transaction.id}</span>
              <span>Amount</span> <span class="numeric">\${g.transaction.amount | numericFormatter: 'fourDec'}</span>
              <span>Quantity</span> <span class="numeric">\${g.transaction.quantity | numericFormatter: 'fourDec'}</span>
              <span>Action type</span> <span>\${g.transaction.actionType | actionType}</span>
            </template>
            <template else>
              <span>Action type</span> <span>\${g.transaction.actionType | actionType}</span>
              <span>Amount</span> <span class="numeric">\${g.transaction.amount | numericFormatter: 'fourDec'}</span>
            </template>
          </div>

          <div class="voucher-graph__lines" ref="linesDiv">
            <span class="mdc-theme--primary">Insight GL transaction</span>
            <table>
              <thead>
                <th>Account</th>
                <th class="numeric">Amount</th>
                <th>VAT code</th>
                <th>Account type</th>
              </thead>
              <tbody>
                <tr repeat.for="l of g.lines">
                  <td>
                    <div class="connector-anchor" ref="rightAnchor">\${l.accountNumber}</div>
                  </td>
                  <td class="numeric">\${l.amount | numericFormatter: 'fourDec'}</td>
                  <td>\${l.vatCode}</td>
                  <td>
                    \${l.glAccountType | accountType}
                    <connector-line left.bind="transactionDiv" right.bind="rightAnchor"></connector-line>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <connector-line left.bind="linesDiv" right.bind="glTransactionsDiv"></connector-line>
        </template>
      </template>

      <template else>
        <template repeat.for="g of groupedByPrimary">
          <connector-line left.bind="voucherDiv" right.bind="insightTransactionsDiv"></connector-line>
          <div class="voucher-graph__insight-transactions" ref="insightTransactionsDiv">
            <span class="mdc-theme--primary">Insight transactions</span>
            <table>
              <thead>
                <th>Id</th>
                <th class="numeric">Amount</th>
                <th class="numeric">Quantity</th>
                <th>Action type</th>
              </thead>
              <tbody>
                <tr repeat.for="t of g.transactions">
                  <td>\${t.id}</td>
                  <td class="numeric">\${t.amount | numericFormatter: 'fourDec'}</td>
                  <td class="numeric">\${t.quantity | numericFormatter: 'fourDec'}</td>
                  <td>\${t.actionType | actionType}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <connector-line left.bind="insightTransactionsDiv" right.bind="linesDiv"></connector-line>
          <div class="voucher-graph__lines" ref="linesDiv">
            <span class="mdc-theme--primary">Insight GL transaction</span>
            <table>
              <thead>
                <th>Account</th>
                <th class="numeric">Amount</th>
                <th>VAT code</th>
                <th>Account type</th>
              </thead>
              <tbody>
                <tr repeat.for="l of g.lines">
                  <td>\${l.accountNumber}</td>
                  <td class="numeric">\${l.amount | numericFormatter: 'fourDec'}</td>
                  <td>\${l.vatCode}</td>
                  <td>\${l.glAccountType | accountType}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <connector-line left.bind="linesDiv" right.bind="glTransactionsDiv"></connector-line>
        </template>
      </template>

      <div if.bind="insightGlTransaction.externalVoucherId" class="voucher-graph__gl-transactions" ref="glTransactionsDiv" style="grid-row: 1/\${groupsCount + 1};">
        <global-progress if.bind="!glTransactions" size="40" stroke-width="3"></global-progress>
        <span class="mdc-theme--primary">GL transactions</span>
        <table>
          <thead>
            <th>Account</th>
            <th class="numeric">Amount</th>
          </thead>
          <tbody>
            <tr repeat.for="t of glTransactions">
              <td>
                <div>\${t.accountCode}</div>
              </td>
              <td class="numeric">\${t.amount | numericFormatter: 'fourDec'}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </template>
</template>
`;
// Exports
export default code;